// Chart and API configuration
export const BASE_LENGTH = 50;
export const LIMIT = 500;
export const API_URL = `${import.meta.env.VITE_API_URL || '/api'}/signals`;

// Trading configuration constants
// NOTE: Keep this in sync with server/config/constants.js FEE_PERCENT
export const DEFAULT_TRADING_FEE_PERCENT = 0.1; // 0.1% default trading fee
